import React, { useEffect, useState } from "react";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import { AddSlabIcon } from "../../../../../utility/constants/assetsManager";
import { secondaryColor } from "../../../../../utility/constants/colorManager";
import { useSnackbar } from "notistack";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { formDataPush } from "../client_onboard/ResellerDetails";
import { SS_AUTH_TOKEN } from "../../../../../utility/constants/secureStorageManager";
import secureStorage from "../../../../../services/secureStorage";
import { API_ENDPOINT } from "../../../../../data/network/services/ApiEndpoint";
import { STATUS_CODE_200 } from "../../../../../utility/constants/valueConstants";
import { fullScreenLoadingSlice } from "../../../../../data/redux/slice/loaderSlice";
function VAN({
  onClickPrevious,
  reduxData,
  onClickCancel,
  onClickNext,
  onSuccess
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [isValuesAdded, setIsValuesAdded] = useState(false);
  const [url, setUrl] = useState("");
  const [totalUrl, setTotalUrl] = useState([]);
  const [loading, setLoading] = useState();
  const dispatch = useDispatch();
  const clientData = useSelector((state) => state.onboardClientSlice);
  const onClickDelete = (id) => {
    const filteredData = totalUrl.filter((val, i) => i !== id);
    setTotalUrl([...filteredData]);
  };

  console.log(reduxData, "Data");

  const onClickAddClient = (data) => {
    dispatch(fullScreenLoadingSlice(true));

    const formdata = formDataPush({ ...clientData, ...data });
    const token = secureStorage.getItem(SS_AUTH_TOKEN);
    fetch(API_ENDPOINT.core_url + "client/create", {
      body: formdata,
      headers: {
        Authorization: "Bearer " + token,
        isimageurl: true
      },
      method: "POST"
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success"
          });
          onSuccess();
        } else {
          enqueueSnackbar(response.message, {
            variant: "error"
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error"
        });
      })
      .finally((res) => {
        dispatch(fullScreenLoadingSlice(false));
      });
  };

  const inputStyle = {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234"
  };
  const containerStyle = {
    maxWidth: "343px",
    height: "44px",
    left: "calc(50% - 343px/2)",
    top: "24px",
    background: "#FFFFFF",
    border: "1px solid #CBCACA",
    borderRadius: "6px",
    color: "#697D95",
    margin: "5px 0 0px 0",
    paddingLeft: "10px"
  };

  return (
    <div>
      <div
        style={{
          width: "100%",
          alignItems: "center",
          marginTop: "20px",
          position: "absolute"
        }}
      >
        <p style={styles.title}>Create VAN</p>
        <p style={styles.p1}>Please fill the necessary details to create VAN</p>
        <div
          style={{
            margin: "10px 0 20px 0",
            height: "1px",
            background: "#38369C"
          }}
        ></div>
        <div style={{ display: "flex", gap: "15%", flexWrap: "wrap" }}>
          {totalUrl &&
            totalUrl.map((data, i) => {
              return (
                <div style={{ minWidth: "343px" }} key={i}>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <label style={styles.label}>Enter Notify URL</label>
                    <MdOutlineDeleteOutline
                      size={20}
                      style={{
                        cursor: "pointer"
                      }}
                      onClick={() => onClickDelete(i)}
                    />
                  </div>
                  <CustomInput
                    disabled={true}
                    value={data}
                    onChange={(data) => setUrl(data)}
                    inputcomponentStyles={{ ...inputStyle }}
                    placeholder="Enter URL"
                    validator="url"
                    type="input"
                    inputStyles={{
                      ...containerStyle
                    }}
                  />
                </div>
              );
            })}
          <div>
            <div style={{ display: "flex", gap: 10 }}>
              <div style={{ minWidth: "343px" }}>
                <label style={styles.label}>
                  {totalUrl.length > 0
                    ? "Enter Validate URL"
                    : "Enter Notify URL"}
                </label>
                <CustomInput
                  value={url}
                  onChange={(data) => setUrl(data)}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Enter URL"
                  validator="url"
                  type="input"
                  inputStyles={{
                    ...containerStyle
                  }}
                />
              </div>
            </div>
            <div
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                margin: "10px 0px",
                width: "auto"
              }}
              onClick={() => {
                if (url.length > 0) {
                  setTotalUrl([...totalUrl, url]);
                  setUrl("");
                  setIsValuesAdded(true);
                } else {
                  enqueueSnackbar("Please enter URL", {
                    variant: "error"
                  });
                }
              }}
            >
              {totalUrl.length < 1 && (
                <>
                  <AddSlabIcon
                    style={{
                      marginRight: 15
                    }}
                  />
                  <p
                    style={{
                      color: secondaryColor,
                      fontSize: 13
                    }}
                  >
                    Add More URL
                  </p>
                </>
              )}
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            marginTop: "20px"
          }}
        >
          <div>
            <CustomButton
              title="Cancel"
              styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
              textStyles={{
                color: "#1E2234",
                fontWeight: "500",
                fontSize: "16px"
              }}
              onClick={onClickCancel}
            />
          </div>
          <div>
            <CustomButton
              title="Previous"
              styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
              textStyles={{
                color: "#1E2234",
                fontWeight: "500",
                fontSize: "16px"
              }}
              onClick={onClickPrevious}
            />
          </div>
          <div>
            <CustomButton
              title="Request to onboard"
              styles={{ background: "#38369C" }}
              textStyles={{
                color: "#FDFDFD",
                fontWeight: "500",
                fontSize: "16px"
              }}
              onClick={() => {
                let obj2 = {};
                if (totalUrl.length > 0 && url !== "") {
                  obj2 = {
                    notifyUrl: totalUrl[0],
                    validateUrl: url
                  };
                } else if (url !== "") {
                  obj2 = { notifyUrl: url };
                }

                let obj = {};
                let arr = [];
                if (reduxData?.service?.notifyUrl === "") {
                  obj = {
                    ...reduxData?.service,
                    ...obj2
                  };
                  arr.push(obj);
                } else {
                  arr = reduxData?.service;
                }

                onClickAddClient({ service: JSON.stringify(arr) });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default VAN;
const styles = {
  title: {
    fontSize: "24px",
    backgroundImage: " linear-gradient(90deg, #4947B8 0%, #FF9700 166.16%)",
    backgroundSize: "100%",
    WebkitBackgroundClip: "text",
    MozBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    MozTextFillColor: "transparent",
    fontWeight: "600",
    width: "fit-content"
  },
  p: {
    color: "#6C6B6B",
    fontWeight: "400",
    fontSize: "14px"
  },
  label: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234"
  },
  cancel: {
    width: "56px",
    height: "19px",

    // background: "#FDFDFD",
    border: "1px solid #38369C",
    borderRadius: "8px"
  },
  select: {
    fontWeight: "400",
    fontSize: "16px",
    color: "#001053"
  },
  add: {
    width: "250px",
    height: "28px",
    display: "flex",
    background: "#EDEEFF",
    borderRadius: "6px",
    margin: "10px 0"
  },
  addUrl: {
    width: "160px",
    height: "28px",
    display: "flex",
    background: "#EDEEFF",
    borderRadius: "6px",
    margin: "10px 0",
    cursor: "Pointer"
  }
};
